import React from 'react'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div>
          <div style={{
            background: 'var(--gradient-brand)',
            padding: '5rem 1rem',
            textAlign: 'center',
            position: 'relative',
            overflow: 'hidden',
          }}>
            <div style={{
              position: 'absolute', inset: 0,
              background: 'radial-gradient(circle at 80% 20%, rgba(255,255,255,0.15), transparent 50%)',
              pointerEvents: 'none',
            }} />
            <div style={{ position: 'relative' }}>
              <div style={{ fontSize: 72, marginBottom: 8 }}>🛠️</div>
              <h1 style={{
                color: '#fff',
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800,
                fontSize: 'clamp(28px, 5vw, 48px)',
                marginTop: 16,
                marginBottom: 12,
                letterSpacing: '-0.02em',
              }}>Something went wrong</h1>
              <p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 18, maxWidth: 500, margin: '0 auto', lineHeight: 1.6 }}>
                We've hit a snag loading this page. Try refreshing — if it keeps happening, please let us know via Support.
              </p>
            </div>
          </div>

          <div className="container" style={{ maxWidth: 600, padding: '3rem 1rem', textAlign: 'center' }}>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn btn-gradient btn-lg" onClick={() => window.location.reload()}>Refresh page</button>
              <button className="btn btn-ghost btn-lg" onClick={() => { window.location.href = '/' }}>Back to home</button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}
